/**
 * Case Conversion Utilities for Rails API ↔ Frontend
 *
 * Rails: snake_case (user_name, created_at)
 * Frontend: camelCase (userName, createdAt)
 */
const DEFAULT_EXCLUDED_KEYS = new Set([
    'id', 'url', 'html', 'css', 'json', 'xml', 'api',
    'href', 'src', 'alt', 'type',
]);
/** Convert snake_case string to camelCase */
export function snakeToCamel(str) {
    return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}
/** Convert camelCase string to snake_case */
export function camelToSnake(str) {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
/** Recursively convert all keys in an object */
export function convertKeys(obj, converter, excludedKeys) {
    if (obj === null || obj === undefined)
        return obj;
    if (Array.isArray(obj))
        return obj.map((item) => convertKeys(item, converter, excludedKeys));
    if (obj instanceof Date)
        return obj;
    if (typeof obj === 'object') {
        const excluded = excludedKeys ?? DEFAULT_EXCLUDED_KEYS;
        const result = {};
        for (const [key, value] of Object.entries(obj)) {
            const newKey = excluded.has(key.toLowerCase()) ? key : converter(key);
            result[newKey] = convertKeys(value, converter, excludedKeys);
        }
        return result;
    }
    return obj;
}
/** Convert keys from snake_case to camelCase (API response → frontend) */
export function toCamelCase(obj, excludedKeys) {
    return convertKeys(obj, snakeToCamel, excludedKeys);
}
/** Convert keys from camelCase to snake_case (frontend → API request) */
export function toSnakeCase(obj, excludedKeys) {
    return convertKeys(obj, camelToSnake, excludedKeys);
}
//# sourceMappingURL=case-converter.js.map